module.exports = __webpack_public_path__ + "media/images/icons/info-icon-478265921356ec15df30112549c0a7dc.svg";